{
  "about.blocks": "باشقۇرۇلىدىغان مۇلازىمېتىر",
  "about.contact": "ئالاقە:",
  "about.default_locale": "كۆڭۈلدىكى",
  "about.disclaimer": "Mastodon ھەقسىز، ئوچۇق كودلۇق يۇمشاق دېتال تاۋار ماركىسى Mastodon gGmbH غا تەۋە.",
  "about.domain_blocks.no_reason_available": "سەۋەبىنى ئىشلەتكىلى بولمايدۇ",
  "about.language_label": "تىل",
  "account.badges.bot": "ماشىنا ئادەم",
  "account.badges.group": "گۇرۇپپا",
  "account.block": "@{name} نى توس",
  "account.block_domain": "{domain} دائىرىنى توس",
  "account.block_short": "توس",
  "account.blocked": "توسۇلدى",
  "account.cancel_follow_request": "ئەگىشىش ئىلتىماسىدىن ۋاز كەچ",
  "account.copy": "تەرجىمىھال ئۇلانمىسىنى كۆچۈر",
  "account.direct": "@{name} نى يوشۇرۇن ئاتا",
  "account.edit_profile_short": "تەھرىر",
  "account.follow_request_cancel_short": "ۋاز كەچ",
  "account.follow_request_short": "ئىلتىماس",
  "account.followers": "ئەگەشكۈچى",
  "account.followers.empty": "تېخى ھېچكىم بۇ كىشىگە ئەگەشمىدى.",
  "account.followers_counter": "{count, plural, one {{counter} ئەگەشكۈچى} other {{counter} ئەگەشكۈچى}}",
  "account.followers_you_know_counter": "تونۇيدىغىنىڭىز {counter}",
  "account.following": "ئەگىشىۋاتىدۇ",
  "account.following_counter": "{count, plural, one {{counter} ئەگىشىۋاتىدۇ} other {{counter} ئەگىشىۋاتىدۇ}}",
  "account.follows.empty": "بۇ ئىشلەتكۈچى تېخى ھېچكىمگە ئەگەشمىدى.",
  "account.follows_you": "سىزگە ئەگەشتى",
  "account.go_to_profile": "تەرجىمىھالغا يۆتكەل",
  "account.posts": "يازما",
  "account.report": "@{name} نى پاش قىل",
  "account_note.placeholder": "چېكىلسە ئىزاھات قوشىدۇ",
  "column.pins": "چوققىلانغان يازما",
  "community.column_settings.media_only": "ۋاسىتەلا",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.placeholder": "What is on your mind?",
  "compose_form.reply": "جاۋاب",
  "compose_form.save_changes": "يېڭىلا",
  "compose_form.spoiler.marked": "مەزمۇن ئاگاھلاندۇرۇشىنى چىقىرىۋەت",
  "compose_form.spoiler.unmarked": "Text is not hidden",
  "compose_form.spoiler_placeholder": "مەزمۇن ئاگاھلاندۇرۇشى (تاللاشچان)",
  "confirmation_modal.cancel": "ۋاز كەچ",
  "confirmations.block.confirm": "توس",
  "confirmations.delete.message": "بۇ يازمىنى راستىنلا ئۆچۈرەمسىز؟",
  "confirmations.delete.title": "يازما ئۆچۈرەمدۇ؟",
  "confirmations.delete_list.confirm": "ئۆچۈر",
  "confirmations.delete_list.message": "بۇ تىزىمنى راستتىنلا مەڭگۈلۈك ئۆچۈرەمسىز؟",
  "confirmations.delete_list.title": "تىزىمنى ئۆچۈرەمدۇ؟",
  "confirmations.discard_edit_media.confirm": "تاشلىۋەت",
  "embed.instructions": "Embed this status on your website by copying the code below.",
  "empty_column.account_timeline": "No toots here!",
  "empty_column.bookmarked_statuses": "You don't have any bookmarked toots yet. When you bookmark one, it will show up here.",
  "empty_column.home": "Your home timeline is empty! Follow more people to fill it up. {suggestions}",
  "empty_column.list": "There is nothing in this list yet. When members of this list post new statuses, they will appear here.",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "keyboard_shortcuts.back": "to navigate back",
  "keyboard_shortcuts.blocked": "to open blocked users list",
  "keyboard_shortcuts.boost": "to boost",
  "keyboard_shortcuts.column": "to focus a status in one of the columns",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.down": "to move down in the list",
  "keyboard_shortcuts.enter": "to open status",
  "keyboard_shortcuts.federated": "to open federated timeline",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "to open home timeline",
  "keyboard_shortcuts.legend": "to display this legend",
  "keyboard_shortcuts.local": "to open local timeline",
  "keyboard_shortcuts.mention": "to mention author",
  "keyboard_shortcuts.muted": "to open muted users list",
  "keyboard_shortcuts.my_profile": "to open your profile",
  "keyboard_shortcuts.notifications": "to open notifications column",
  "keyboard_shortcuts.open_media": "to open media",
  "keyboard_shortcuts.pinned": "to open pinned toots list",
  "keyboard_shortcuts.profile": "to open author's profile",
  "keyboard_shortcuts.reply": "to reply",
  "keyboard_shortcuts.requests": "to open follow requests list",
  "keyboard_shortcuts.search": "to focus search",
  "keyboard_shortcuts.spoilers": "to show/hide CW field",
  "keyboard_shortcuts.start": "to open \"get started\" column",
  "keyboard_shortcuts.toggle_hidden": "to show/hide text behind CW",
  "keyboard_shortcuts.toggle_sensitivity": "to show/hide media",
  "keyboard_shortcuts.toot": "to start a brand new toot",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "to move up in the list",
  "navigation_bar.domain_blocks": "Hidden domains",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.reblog": "{name} boosted your status",
  "notifications.column_settings.status": "New toots:",
  "privacy.change": "Adjust status privacy",
  "report.placeholder": "Type or paste additional comments",
  "report.submit": "Submit report",
  "report.target": "Report {target}",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "search_results.statuses": "Toots",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_status": "Open this status in the moderation interface",
  "status.copy": "Copy link to status",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.open": "Expand this status",
  "status.reblogs.empty": "No one has boosted this toot yet. When someone does, they will show up here.",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "upload_progress.label": "Uploading…"
}
